import Airtable from "airtable";
export const handleOnError = (error) => {
  // Handle the error here
  const base = new Airtable({
    apiKey:
      "patEw5kTW6pJ2qcyG.94ddbc442546a87537c9466bf83ee9ab966d83676463f12f8cbbac217027e6ba",
  }).base("app97usFRonrWD3ge");
  base("Error").create({
    "Application Name": "Dompet Kartini",
    "Environment": process.env.NODE_ENV,
    "Error Name": error.name,
    "Error Message": error.message,
    "Stack Trace": error.stack,
  });
};
